(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-slider"] && !Shopify.designMode) return;
  try {
    
   
  $(document).ready(function(){
    $('.custom-slider').slick({
     infinite: true,
      arrows: false,
      autoplay: true,
      variableWidth: true,
      speed: 500,
      slidesToScroll: 1,         // Smallest scroll
      swipeToSlide: true,        // Enables direct swipe control
      touchThreshold: 10,        // Improves touch response
      cssEase: 'ease-in-out',  // Smoother easing
      responsive: [
    {
      breakpoint: 1024,
      settings: {
        variableWidth: true,
        slidesToScroll: 1,
        infinite: true,
        dots: true
      }
    },
    {
      breakpoint: 767,
      settings: {
        variableWidth: false,
        slidesToShow: 1
      }
    }
    ]
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
  .then(response => response.text())
  .then(text => {
    const html = document.createElement('div');
    html.innerHTML = text;
    const recommendations = html.querySelector('product-recommendations');

    if (recommendations && recommendations.innerHTML.trim().length) {
      this.innerHTML = recommendations.innerHTML;
    }

    // ── FILTRO GENERE ──
    const currentGender = this.dataset.gender;
    const MAX_VISIBLE = 4;

    if (currentGender) {
  const allCards = Array.from(this.querySelectorAll('.card.card--product[data-gender]'));
  
  allCards.forEach((card) => {
    const gridItem = card.closest('.grid > div') || card.parentElement;
    
    if (card.dataset.gender !== currentGender) {
      // genere sbagliato → rimuovi sempre
      gridItem.remove();
    }
  });

  // Taglia i risultati rimasti a MAX_VISIBLE
  const remaining = Array.from(this.querySelectorAll('.card.card--product'));
  remaining.forEach((card, index) => {
    if (index >= MAX_VISIBLE) {
      const gridItem = card.closest('.grid > div') || card.parentElement;
      gridItem.remove();
    }
  });
}

    if (this.querySelector('.card.card--product')) {
      this.classList.add('product-recommendations--loaded');
    }
  })
  .catch(e => console.error(e));
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
